<template>
  <div class="checkbox">
    <v-checkbox v-model="val" :label="fields[name].name"></v-checkbox>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    name: 'Checkbox',
    data() {
      return {
        val: true
      }
    },
    watch: {
      val(newValue) {
        this.setField({fieldId: this.name, fieldPropertyId: 'value', value: newValue})
      }
    },
    methods: {
      ...mapMutations([
        'setField'
      ])
    },
    created() {
      if (localStorage.hasOwnProperty(this.$route.path)) {
        let savedData = JSON.parse(localStorage.getItem(this.$route.path))
        if (savedData.hasOwnProperty(this.name)) this.val = savedData[this.name]
      }
    },
    props: ['name'],
    computed: {
      ...mapState([
        'fields'
      ])
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/create-form/Checkbox.vue